import { render } from "./RhRadiobox.vue?vue&type=template&id=4773819f&scoped=true&ts=true"
import script from "./RhRadiobox.vue?vue&type=script&lang=ts"
export * from "./RhRadiobox.vue?vue&type=script&lang=ts"

import "./RhRadiobox.vue?vue&type=style&index=0&id=4773819f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4773819f"]])

export default __exports__